document.addEventListener("DOMContentLoaded", function() {
    const topBar  = document.querySelector('.tw-bg-primary');
    const mobileLeft = document.querySelector('.mobile_left');
    const mobileOpen = mobileLeft.querySelector('.mobile-open');
    const mobileClosed = mobileLeft.querySelector('.mobile-closed');
    const mobileMenuContainer = document.querySelector('.mobile-menu-container');
    const mainMobileMenu = document.querySelector('#mobile_nav');
    const html = document.querySelector('html');
   /*
     const body = document.querySelector('body');
    function updateMenuHeight() {
       const viewportHeight = window.innerHeight + 'px';
      mobileMenuContainer.style.height = viewportHeight;
    }
      function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    const adjustMenuHeight = debounce(function() {
        updateMenuHeight();
    }, 100);

  window.addEventListener('scroll', adjustMenuHeight);
*/
mobileLeft.addEventListener('click', function() {
    if (mobileOpen.style.display !== 'none') {
        mobileOpen.style.display = 'none';
        mobileClosed.style.display = 'inline-block';
        if (topBar) {
            topBar.style.display = 'none';
        }
        mainMobileMenu.classList.add('mobile-height');
        //body.classList.add('body-no-scroll');
         html.classList.add('body-no-scroll');
       // updateMenuHeight();
    } else {
        mobileOpen.style.display = 'inline-block';
        mobileClosed.style.display = 'none';
        if (topBar) {
            topBar.style.display = 'block';
        }
       mainMobileMenu.classList.remove('mobile-height');
       // body.classList.remove('body-no-scroll');
        html.classList.remove('body-no-scroll');
       // mobileMenuContainer.style.height = '0';
    }
    mobileMenuContainer.classList.toggle('opened');
});

  // Handle window resize
//window.addEventListener('resize', updateMenuHeight);



   var shopButton = document.querySelector(".shop-button");
    var shopArrow = document.querySelector(".shop-arrow");
    var headerBlockMega = document.querySelector(".header-block-mega");
    var timeout;
   
    shopButton.addEventListener("click", function() {
      if (headerBlockMega.style.display === "flex") {
          headerBlockMega.style.display = "none";
        shopArrow.style.transform = "rotate(0deg)";
      } else {
          headerBlockMega.style.display = "flex";
          shopArrow.style.transform = "rotate(180deg)";
      }
    });
    function hideDropdownWithDelay() {
        timeout = setTimeout(function() {
            if (!shopButton.matches(':hover') && !headerBlockMega.matches(':hover')) {
                headerBlockMega.style.display = "none";
                shopArrow.style.transform = "rotate(0deg)";
            }
        }, 300);  // 300ms delay before hiding
    }
    headerBlockMega.addEventListener("mouseleave", hideDropdownWithDelay);
    headerBlockMega.addEventListener("mouseenter", function() {
        clearTimeout(timeout);
    });


  
});
